import type { ReactNode } from "react"
import { cn } from "@/shared/lib/cn"

/**
 * Cabecalho de secao: sobrelinha dourada, titulo e texto de apoio.
 *
 * Sete secoes repetiam exatamente estas tres classes de tipografia. Centralizar
 * aqui e o que mantem a escala tipografica consistente quando uma secao nova
 * for escrita meses depois.
 */
export interface SectionHeadingProps {
  eyebrow: string
  title: ReactNode
  description?: ReactNode
  /** Encaixa o `id` do titulo para uso em aria-labelledby da secao. */
  titleId?: string
  className?: string
}

export function SectionHeading({ eyebrow, title, description, titleId, className }: SectionHeadingProps) {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      <span className="text-xs font-semibold tracking-widest uppercase text-dourado-escuro">{eyebrow}</span>

      <h2
        id={titleId}
        className="text-3xl lg:text-[42px] font-medium text-verde-profundo leading-[1.1] tracking-tight"
      >
        {title}
      </h2>

      {description ? (
        <p className="text-base text-verde-profundo/55 leading-relaxed">{description}</p>
      ) : null}
    </div>
  )
}
